export enum InitiativeType {
	Chore = 2,
	Improvement = 1
}
